import browse from './browse.vue';
import form from './form.vue';
import read from './read.vue';

export default {
  browse,
  create: form,
  read,
  edit: form,
};
